import { styled } from '@mui/material/styles';
import { ListItemText } from '@sunwisesoftware/sunwise-ui';

export default styled(ListItemText)(({ drawersize, theme }) => ({
    '& .MuiListItemText-primary': {
        color: theme.palette.primary.main,
        fontSize: drawersize === '14px',
        lineHeight: 'initial',
        marginLeft: '16px',
        textAlign: 'left',
    },
}));
